import { useState } from "react";
import { formatTime } from "../../utils/formatters";
import styles from "./ActivityPage.module.css";

const TYPE_LABELS = {
  IN: "IN",
  OUT: "OUT",
  WORK_ORDER: "W/O",
  DELIVERY: "DEL",
};

export default function ActivityPage({ transactions }) {
  const [typeFilter, setTypeFilter] = useState("");
  const [search, setSearch] = useState("");

  const filtered = transactions
    .filter(t => (!typeFilter || t.type === typeFilter) &&
      (!search || t.productName?.toLowerCase().includes(search.toLowerCase()) ||
       t.performedBy?.toLowerCase().includes(search.toLowerCase())))
    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

  const getActiveFilterClass = (v) => {
    if (typeFilter !== v) return styles.filterBtn;
    if (v === "IN") return styles.filterBtnIn;
    if (v === "OUT" || v === "WORK_ORDER" || v === "DELIVERY") return styles.filterBtnOut;
    return styles.filterBtnAll;
  };

  const isAddType = (type) => type === "IN";

  return (
    <div className={styles.container}>
      <div className={styles.toolbar}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search transactions..."
          className={styles.searchInput} />
        <div className={styles.filterGroup}>
          {[["", "All"], ["IN", "IN"], ["OUT", "OUT"], ["WORK_ORDER", "Work Order"], ["DELIVERY", "Delivery"]].map(([v, l]) => (
            <button key={v} onClick={() => setTypeFilter(v)} className={getActiveFilterClass(v)}>
              {l}
            </button>
          ))}
        </div>
      </div>
      {filtered.length === 0 ? (
        <div className={styles.empty}>
          <div className={styles.emptyIcon}>list</div>
          <div className={styles.emptyText}>No transactions yet. Start scanning to log activity.</div>
        </div>
      ) : (
        <div className={styles.grid}>
          {filtered.map(tx => (
            <div key={tx.id} className={isAddType(tx.type) ? styles.txCardIn : styles.txCardOut}>
              <div className={styles.txBody}>
                <div className={isAddType(tx.type) ? styles.txBadgeIn : styles.txBadgeOut}>
                  {TYPE_LABELS[tx.type] || tx.type}
                </div>
                <div className={styles.txInfo}>
                  <div className={styles.txProductName}>{tx.productName}</div>
                  <div className={styles.txProductMeta}>{tx.manufacturer} - {tx.barcode || tx.productId}{tx.lotNumber ? ` | Lot: ${tx.lotNumber}` : ""}</div>
                  {tx.workOrderId && <div className={styles.txLinkId}>WO: {tx.workOrderId}</div>}
                  {tx.deliveryId && <div className={styles.txLinkId}>Delivery: {tx.deliveryId}</div>}
                  {tx.notes && <div className={styles.txNotes}>"{tx.notes}"</div>}
                </div>
                <div className={styles.txQtyCol}>
                  <div className={isAddType(tx.type) ? styles.txQtyIn : styles.txQtyOut}>
                    {isAddType(tx.type) ? "+" : "-"}{tx.quantity}
                  </div>
                  <div className={styles.txStockAfter}>{tx.stockAfter} left</div>
                </div>
              </div>
              <div className={styles.txFooter}>
                <span>by {tx.performedBy}</span>
                <span>{formatTime(tx.timestamp)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
